import React, { useState } from "react";
import UsersTable from "./users/UsersTable";
import UsersModal from "./users/UsersModal";
import { UserAddOutlined } from "@ant-design/icons";
import "./workingmonth.css";

const Users = () => {
  const [isModalVisible, setIsModalVisible] = useState(false);
  const openUserModal = () => {
    setIsModalVisible(true);
  };
  return (
    <div className="wm-page">
      <UsersTable
        isModalVisible={isModalVisible}
        setIsModalVisible={setIsModalVisible}
        headerExtra={
          <button
            type="button"
            className="wm-btn wm-btn-primary wm-btn-sm"
            onClick={openUserModal}
          >
            <UserAddOutlined /> Adaugă utilizator
          </button>
        }
      />
      {typeof isModalVisible === "boolean" && isModalVisible ? (
        <UsersModal
          isModalVisible={isModalVisible}
          setIsModalVisible={setIsModalVisible}
        />
      ) : null}
    </div>
  );
};

export default Users;
